module.exports = __webpack_public_path__ + "img/UC3200.a344c524.png";